export default /* graphql */ `
query($preview: Boolean, $category: String, $slug: String) {
  newsCollection(preview: $preview, limit: 3, where:{category: $category, slug_not: $slug}, order: [date_DESC]) {
	  items {
      sys { id }
    	title
      slug
      date
      category
      copy { json }
      image
      heroImage {
        width
        height
        thumbnail: url(transform: {
            width: 800,
            format: JPG,
            quality: 90
          })
      }
	  }
  }
}
`
